export const zeroID = "00000000-0000-0000-0000-000000000000";

export const AWS_COGNITO_CLIENT_ID = process.env.appConfig["aws.cognito"]["client.id"];
export const AWS_COGNITO_HOST = process.env.appConfig["aws.cognito"]["host"];
